<fd-panel [fixed]="true">
  <div class="panel-title-container">
    <div class="panel-title-left" width="15px">
      @if (iconType !== null) {
        <div class="icon-resource-type">
          <app-icon
            class="title-icon"
            [icon]="$any(iconType) | resourceGlyph"
            size="lg"
          ></app-icon>
        </div>
      }

      <h5 class="header-text" fd-panel-title>{{ headerTitle }}</h5>
    </div>

    <div>
      <ng-container *ngTemplateOutlet="rightHeaderContent"></ng-container>
      <app-full-screen-button
        [selector]="selector"
        (clickEvent)="this.clickEvent.emit(false)"
        [isExpand]="false"
      >
      </app-full-screen-button>
    </div>
  </div>
</fd-panel>
